import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider";
import { useUserModalContext } from "../../../Contexts/UserModalContext/UserModalProvider";
import { NoticeInterface } from "../../../Interfaces/Entities";
import CreateNewsLetterComponent from "../../../Components/SharedComponents/CreateData/CreateNewsLetterComponent";


function UserCreateNewsLetterModal() {

	const { allNotices, setAllNotices } = useUserModalContext()
	const { setCurrentModal } = useGeneralContext()

	const updateNotices = (newNotice : NoticeInterface) => {
		const updatedNotices = [newNotice, ...allNotices]
		setAllNotices(updatedNotices)
		setCurrentModal('NoticeList')
	}


	return (
		<CreateNewsLetterComponent 
			updateContext={updateNotices}
		/>
	)
}

export default UserCreateNewsLetterModal